import { all, fork } from 'redux-saga/effects';
import { SagaIterator } from 'redux-saga';
import authSaga from './authSaga';
import vocabularySaga from './vocabularySaga';
import exerciseSaga from './exerciseSaga';
import dashboardSaga from './dashboardSaga';
import lessonsSaga from './lessonsSaga';
import achievementsSaga from './achievementsSaga';
import sessionSaga from './sessionSaga';
import testingSaga from './testingSaga';
import speakingSaga from './speakingSaga';
import readingSaga from './readingSaga';
import learningProgressSaga from './learningProgressSaga';
import conversationSaga from './conversationSaga';
import progressSaga from './progressSaga';
import studentProgressSaga from './studentProgressSaga';
import writingSaga from './writingSaga';
import listeningSaga from './listeningSaga';
import grammarSaga from './grammarSaga';
import { syllabusSaga } from './syllabusSaga';

export default function* rootSaga(): SagaIterator {
    yield all([
        fork(authSaga),
        fork(vocabularySaga),
        fork(exerciseSaga),
        fork(dashboardSaga),
        fork(lessonsSaga),
        fork(achievementsSaga),
        fork(sessionSaga),
        fork(testingSaga),
        fork(speakingSaga),
        fork(readingSaga),
        fork(learningProgressSaga),
        fork(conversationSaga),
        fork(progressSaga),
        fork(studentProgressSaga),
        fork(writingSaga),
        fork(listeningSaga),
        fork(grammarSaga),
        fork(syllabusSaga),
    ]);
}
